import {ApiClientService, EntityApiService} from '@dofleini/security';

class QuestionnaireApiService extends EntityApiService {

    getOne = ({questionnaireId}) => ApiClientService.get(this.getPath(`/${questionnaireId}`));

    manageEvidence = ({questionnaireId, ...params}) => ApiClientService.patch(this.getPath(`/${questionnaireId}/images`), params);


}

export default new QuestionnaireApiService('/ms-core/api/questionnaire-ies');
